import { ApolloProvider } from "@apollo/client";
import type { ReactNode } from "react";

import { useClient } from "./useClient";

interface Props {
  children: ReactNode;
}

const ApolloClientProvider = ({ children }: Props) => {
  const client = useClient();

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export { ApolloClientProvider };
